import { connectedStore } from '../../../store';
import constants from '../../constants';
import view from '../../../view';
import template from '../../../template';

const { TEXT_COLOR_OPTIONS_VARIABLE } = constants;

const getCustomTextColorsStylesheet = () => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);

  if (!variables[TEXT_COLOR_OPTIONS_VARIABLE]) return null;

  const { id: targetTitle } = variables[TEXT_COLOR_OPTIONS_VARIABLE][0];
  const liveDom = view.accessors.getLiveDocument();

  return Array.from(liveDom.styleSheets).find((item) => item.title === targetTitle) || null;
};

export default getCustomTextColorsStylesheet;
